import React  from 'react';
import NumberComponentProto from './number-proto.jsx';


export default function renderNumberInList(id, props) {
    return <NumberComponentProto renderMode="form-new" id={id} {...props} />;
}